import { faker } from '@faker-js/faker';

import type { EquityInvestmentPageVisitedGetResponse } from '../types/EquityInvestmentPageVisitedGetResponse';

export function createEquityInvestmentPageVisitedGetResponse(
  data: NonNullable<Partial<EquityInvestmentPageVisitedGetResponse>> = {}
): NonNullable<EquityInvestmentPageVisitedGetResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
